import { fetchData, fetchGetData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export const fetchScenarioLibraryData = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.FETCH_SCENARIO_LIBRARY_DATA, payload);
  return response;
};

export const fetchScenarioEditData = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.EDIT_SCENARIO, payload);
  return response;
};

export const fetchUserDataAPI = async () => {
  const response = await fetchGetData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.FETCH_USER_DATA);
  return response;
};

export const scenarioShareAPI = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.SCENARIO_SHARE_FUNCTIONALITY, payload);
  return response;
};

export const downloadBasePriceAPI = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.DOWNLOAD_BASE_PRICE_API, payload);
  return response;
};

export const uploadBasePriceAPI = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_LIBRARY.UPLOAD_BASE_PRICE_API, payload);
  return response;
};
